import { useKeycloak } from '@react-keycloak/web';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import Layout from './Layout';
import ProjectProvider from '../../contexts/ProjectContext';
import ServerProvider from '../../contexts/ServerContext';
import SolrInstanceProvider from '../../contexts/SolrContext';
import ToastProvider from '../../contexts/ToastContext';
import UserProvider from '../../contexts/UserContext';

const PrivateLayoutRoute = ({ element, layoutProps = {} }) => {
  const { i18n } = useTranslation();
  const { keycloak } = useKeycloak();

  const handleLogout = () => {
    keycloak.logout({
      redirectUri: import.meta.env.VITE_APP_KANDASEARCH_HOME_PAGE,
    });
  };

  return keycloak?.authenticated ? (
    <ToastProvider>
      <UserProvider>
        <ProjectProvider>
          <SolrInstanceProvider>
            <ServerProvider>
              <Layout handleLogout={handleLogout} {...layoutProps}>
                {element}
              </Layout>
            </ServerProvider>
          </SolrInstanceProvider>
        </ProjectProvider>
      </UserProvider>
    </ToastProvider>
  ) : (
    keycloak.login({ locale: i18n.language })
  );
};

PrivateLayoutRoute.propTypes = {
  element: PropTypes.element,
  layoutProps: PropTypes.object,
};

export default PrivateLayoutRoute;
